export default {
  viewBase: {
    'a1': '健康動態',
    'a2': '取消',
    'a3': '刪除',
    'a4': '添加家人，關注家人健康',
    'a5': 'HRV心臟指數',
    'a6': '未測量',
    'a7': '呼吸暫停次數',
    'a8': '次',
    'a9': '呼吸暫停',
    'a10': 'hrv',
    'a11': '血糖',
    'a12': '心率',
    'a13': '心電',
    'a14': '心臟負荷',
    'a15': '血氧',
    'a16': '動脈硬化指數',
    'a17': 'sos預警',
    'a18': '健康分析',
    'a19': '血壓',
    'a20': '正常',
    'a21': '偏高',
    'a22': '偏低',
    'a23': 'BMI',
    'a24': '運動',
    'a25': '刪除成功',
    'a26': '刪除失敗',
    'a27': '您沒有可以編輯的家人',
    'a28': '選擇家人關係',
    'a29': '家人關係',
    'a30': '請輸入手機號碼',
    'a31': '手機號碼',
    'a32': '立即綁定',
    'a33': '男',
    'a34': '女',
    'a35': '家人關係未選擇',
    'a36': '手機號格式錯誤',
    'a37': '綁定成功',
    'a38': '拒絕',
    'a39': '同意',
    'a40': '已添加',
    'a41': '已拒絕',
    'a42': '確定刪除嗎？ ',
    'a43': '加載中...',
    'a44': '確定拒絕家人關係嗎？ ',
    'a45': '確定同意家人關係嗎？ ',
    'a46': '已經到底了',
    'a47': '暫無數據',
    'a48': '週',
    'a49': '月',
    'a50': '開始時間',
    'a51': '結束時間',
    'a52': '趨勢統計',
    'a53': '數據分析',
    'a54': '項目',
    'a55': '本週',
    'a56': '本月',
    'a57': '上週',
    'a58': '上月',
    'a59': '總測量（次）',
    'a60': '正常（次）',
    'a61': '異常（次）',
    'a62': '平均數值',
    'a63': '最高值',
    'a64': '最低值',
    'a65': '步',
    'a66': '儲存',
    'a67': '大頭貼',
    'a68': '姓名',
    'a69': '請輸入姓名',
    'a70': '臟音',
    'a71': '選擇性別',
    'a72': '請選擇',
    'a73': '請輸入詳細地址',
    'a74': '姓名未填寫',
    'a75': '性別未選擇',
    'a76': '出生日期未選擇',
    'a77': '成功',
    'a78': '詳細地址',
    'a79': '性別',
    'a80': '出生日期',
    'a81': '確定',
    'a82': '經度',
    'a83': '緯度',
    'a84': '總（次）',
    'a85': '平均',
    'a86': '高值',
    'a87': '低值',
    'a88': '正常',
    'a89': '異常',
    'a90': '時間查詢',
    'a91': '步數',
    'a92': '手動錄入',
    'a93': '請輸入步數',
    'a94': '處理失敗，請重試'
  }
}

